/*
 * push-notification-subscription (zod)
 */
import { globalCreateExclude, globalUpdateExclude } from "../../utils/constants"
import { createInsertSchema, createSelectSchema } from "drizzle-zod"
import * as z from "zod"
import { pushNotificationSubscriptions } from "./push-notification-subscription.schema"

/* Select */
export type PushNotificationSubscription = z.infer<
	typeof selectPushNotificationSubscriptionSchema
>
export const selectPushNotificationSubscriptionSchema = createSelectSchema(
	pushNotificationSubscriptions,
)

/* Filters */
export type PushNotificationSubscriptionFilters = z.infer<
	typeof pushNotificationSubscriptionFiltersSchema
>
export const pushNotificationSubscriptionFiltersSchema = z.object({
	id: z.string().optional(),
	userId: z.string().optional(),
	active: z.boolean().optional(),
})

/* Create */
export const createPushNotificationSubscriptionSchema = createInsertSchema(
	pushNotificationSubscriptions,
).partial(globalCreateExclude)
export type CreatePushNotificationSubscription = z.infer<
	typeof createPushNotificationSubscriptionSchema
>

/* Update */
export const updatePushNotificationSubscriptionSchema = createInsertSchema(
	pushNotificationSubscriptions,
)
	.omit(globalUpdateExclude)
	.required({ id: true })
export type UpdatePushNotificationSubscription = z.infer<
	typeof updatePushNotificationSubscriptionSchema
>

/* Delete */
export const deletePushNotificationSubscriptionSchema = createInsertSchema(
	pushNotificationSubscriptions,
).required({ id: true })
export type DeletePushNotificationSubscription = z.infer<
	typeof deletePushNotificationSubscriptionSchema
>
